import './Loading.css';

const Loading = () => {
  return <div className='loading'>Loading...</div>;
};

export default Loading;
